module.exports = __webpack_public_path__ + "static/media/lil-logo.37031f1e.svg";